import EllipsisText from "@/components/ellipsis-text/EllipsisText"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { getFormattedDate } from "@/helpers/getFormattedDate"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { Rate } from "antd"
import { FC } from "react"
import "./ReviewCard.less"
import quotes from "./images/quotes.png"
import headerBg from "./images/review-header-image.png"

const { Text } = WebsiteTypography
type Props = {
  it: ComponentUiReview
  onClick?: (it: ComponentUiReview) => void
}

const ReviewCard: FC<Props> = ({ it, onClick }) => {
  const { sm, md, lg, xl, xxl } = useBreakpoint()
  const sizeNames = xxl ? "md" : xl ? "md" : "sm"

  return (
    <div className={"review-card"} onClick={() => onClick?.(it)}>
      <div className={"review-card-header"}>
        <div className={"header-icon-wrapper"}>
          <img src={quotes} alt={""} />
        </div>
        <div className={"review-header-bg"}>
          <img src={headerBg} alt={""} />
        </div>
      </div>

      <div className={"review-card-content"} style={{ fontSize: 14 }}>
        <div className={"title-wrapper"}>
          <EllipsisText
            text={it?.title}
            ellipsisLength={38}
            rows={2}
            color={"white"}
            size={"xl"}
            weight={"w700"}
            maxWidth={xxl || xl || lg ? 330 : 290}
          />
        </div>

        <EllipsisText
          text={it?.content}
          ellipsisLength={150}
          rows={7}
          size={"lg"}
          color={"website-secondary"}
          lh={"lh-lg"}
          maxWidth={xxl || xl || lg ? 330 : 290}
          style={{ textAlign: "left" }}
        />
      </div>

      <div className={"review-card-footer"}>
        <div className={"text-block"}>
          <EllipsisText
            text={it?.clientName}
            ellipsisLength={xxl ? 10 : xl ? 10 : lg ? 16 : md ? 10 : sm ? 10 : 10}
            rows={1}
            size={sizeNames}
            color={"orange"}
            maxWidth={xxl || xl || lg ? 200 : 140}
            style={{
              textTransform: "uppercase",
            }}
          />

          <Text color={"website-secondary"} size={"xs"}>
            {getFormattedDate(it?.feedbackDate)}
          </Text>
        </div>
        <Rate allowHalf disabled defaultValue={it?.rate ? it?.rate : 5} className={"review-rate-box"} />
      </div>
    </div>
  )
}

export default ReviewCard
